// State enum for async operations
const AsyncStatus = Object.freeze({
	// Request hasn't been sent
	INIT: 'INIT',

	// Request has been sent, and response is pending
	PENDING: 'PENDING',

	// Successful response received
	SUCCESS: 'SUCCESS',

	// Request resulted in an error
	FAILURE: 'FAILURE'
});


export default AsyncStatus;



// WEBPACK FOOTER //
// ./src/enums/AsyncStatus.js